export default __webpack_public_path__ + "static/media/Yudovin.5e59bfdd.png";